import Vue from 'vue'
import Vuex from 'vuex'

import mobile from './modules/mobile'
import excelMassiveDownload from './modules/excelMassiveDownload'
import dashCustomCards from './modules/dashCustomCards'

import accumulatedSales from './modules/accumulatedSales'
import agGridPivot from './modules/agGridPivot'
import storeGrowth from './modules/storeGrowth'
import usersAdmin from './modules/usersAdmin'
import priceAudition from './modules/priceAudition'
import gridMetricSystemWideOneMetric from './modules/gridMetricSystemWideOneMetric'
import productWm from './modules/productWm'
import dimensionFilterQuickAccess from './modules/dimensionFilterQuickAccess'
import filterRequestObject from './modules/filterRequestObject'
import generalKeyKpiAnalysis from './modules/generalKeyKpiAnalysis'
import sellOutDashboardCard from './modules/sellOutDashboardCard'

//Estados de la nueva arquitectura!

import massiveDownload from '@/app/massive_download/MassiveDownloadState'
import salesAnalysisStore, { NAMESPACE as salesAnalysisNamespace } from '@/app/sales_analysis/store/Index'
import storeGrowthStore, { NAMESPACE as storeGrowthStoreNamespace } from '@/app/store_growth/store/Index'
import stockBreak, { NAMESPACE as stockBreakNamespace } from '@/app/stock_break/store/Index'
import weeklySales, { NAMESPACE as weeklySalesNamespace } from '@/app/weekly_sales/store/Index'

import dailySales, { NAMESPACE as dailySalesNamespace } from '@/app/daily_sales/store/Index'
import admin, { NAMESPACE as adminNamespace } from '@/app/admin/store/Index'
import monthlySales, { NAMESPACE as monthlySalesNamespace } from '@/app/monthly_sales/store/Index'
import workspace, { NAMESPACE as workspacesNamespace } from '@/app/workspaces/store/Index'
import productFollowUp, { NAMESPACE as productFollowUpNameSpace } from '@/app/product_follow_up/store/Index'
import selloutDashboard, { NAMESPACE as selloutDashboardNameSpace } from '@/app/sellout_dashboard/store/Index'


import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const initialState = () => ({
  metric: null,
  selectedMetricOption: null,
  globalFilters: '',
  routingFromInit: false,
  selectedView: '',
  selectedWeek: {
    index: '',
    category: '',
    year: 0
  },
  appAvailableHeight: 500,
  desktopParameterConfig: null,
  selectedRangeOption: 'dynamicRanges'
})

Vue.use(Vuex)
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production', // process.env.NODE_ENV !== 'production',
  getters,
  actions,
  mutations,
  modules: {
    mobile,
    excelMassiveDownload,
    dashCustomCards,
    accumulatedSales,
    agGridPivot,
    storeGrowth,
    usersAdmin,
    priceAudition,
    gridMetricSystemWideOneMetric,
    productWm,
    stockBreak,
    dimensionFilterQuickAccess,
    filterRequestObject,
    generalKeyKpiAnalysis,
    sellOutDashboardCard,
    massiveDownload,
    'salesAnalysis': salesAnalysisStore,
    [storeGrowthStoreNamespace]: storeGrowthStore,
    [stockBreakNamespace]: stockBreak,
    [weeklySalesNamespace]: weeklySales,
    [dailySalesNamespace]: dailySales,
    [adminNamespace]: admin,
    [monthlySalesNamespace]: monthlySales,
    [workspacesNamespace]: workspace,
    [productFollowUpNameSpace]: productFollowUp,
    [selloutDashboardNameSpace]: selloutDashboard
  },
  state: initialState(),
});

if (module.hot) {

  module.hot.accept([
    '@/app/sales_analysis/store/Index',
    '@/app/store_growth/store/Index',
    '@/app/stock_break/store/Index',
    '@/app/admin/store/Index',
    '@/app/daily_sales/store/Index'
  ], () => {
    // require the updated modules
    // have to add .default here due to babel 6 module output
    const salesAnalysisModule = require('@/app/sales_analysis/store/Index').default
    const storeGrowthModule = require('@/app/store_growth/store/Index').default
    const stockBreakModule = require('@/app/stock_break/store/Index').default
    const weeklySalesModule = require('@/app/weekly_sales/store/Index').default
    const dailySalesModule = require('@/app/daily_sales/store/Index').default
    const adminModule = require('@/app/admin/store/Index').default
    const monthlySalesModule = require('@/app/monthly_sales/store/Index').default
    // swap in the new modules and mutations
    store.hotUpdate({
      modules: {
        'salesAnalysis': salesAnalysisModule,
        'storeGrowth': storeGrowthModule,
        'stockBreak': stockBreakModule,
        'weeklySales': weeklySalesModule,
        'dailySales': dailySalesModule,
        'admin': adminModule,
        'monthlySales': monthlySalesModule,
      }
    })
  })
}
export default store



// WEBPACK FOOTER //
// ./src/store/index.js